import { Typography } from 'antd';
import { TranslatableBox } from '../boxes/TranslatableBox';

export function AppTitle({ as, ...rest }) {
  return <TranslatableBox {...rest} as={Typography.Title} />;
}
